<script setup lang="ts">
import { onMounted, reactive, watch } from "vue";
import { router } from "@inertiajs/vue3";
import { pickBy } from "lodash-es";
import TheLayoutApp from "@/Layouts/TheLayoutApp.vue";
import AppHeader from "@/Components/Shared/header/AppHeader.vue";
import AppTitle from "@/Components/Shared/title/AppTitle.vue";
import AppContainer from "@/Components/Shared/container/AppContainer.vue";
import AppPage from "@/Components/Shared/page/AppPage.vue";
import AppPlaceholder from "@/Components/Shared/placeholder/AppPlaceholder.vue";
import AppUserGrid from "@/Components/Shared/user/AppUserGrid.vue";
import AppProductGrid from "@/Components/Shared/product/AppProductGrid.vue";
import AppCategoryGrid from "@/Components/App/categories/AppCategoryGrid.vue";
import AppBrandGrid from "@/Components/App/brands/AppBrandGrid.vue";
import AppProductGridSkeleton from "@/Components/Shared/product/AppProductGridSkeleton.vue";

type Props = {
    products?: object;
    categories?: object;
    brands?: object;
    users?: object;
    filters?: object;
    allCategories: object;
};

const {
    products,
    categories = undefined,
    brands = undefined,
    users = undefined,
    filters = undefined,
    allCategories = undefined,
} = defineProps<Props>();

const form = reactive({
    categories: filters && filters.categories ? filters.categories : [],
    brands: filters && filters.brands ? filters.brands : [],
    s: filters && filters.s ? filters.s : "",
});

onMounted(() => {
    router.reload({
        only: ["products"],
    });
});

// watchers
watch(form, () => {
    const query = pickBy(form);
    router.get(
        "/zoeken",
        Object.keys(query).length ? query : { remember: "forget" },
        { preserveState: false },
    );
});
</script>

<template>
    <TheLayoutApp title="Producten">
        <AppContainer size="large">
            <AppPage size="small">
                <AppHeader size="large">
                    <AppTitle size="large">
                        Zoeken
                        <template v-if="form.s"
                            >naar "{{ form.s }}"</template
                        ></AppTitle
                    >
                </AppHeader>

                <div class="flex flex-col gap-8 md:gap-20">
                    <section>
                        <AppHeader>
                            <AppTitle as="h2"> Producten </AppTitle>
                        </AppHeader>

                        <AppProductGridSkeleton
                            v-if="!products"
                            size="large"
                        />
                        <AppProductGrid
                            v-else-if="products.data && products.data.length"
                            :products="products.data"
                            :meta="products.meta"
                            size="large"
                        />
                        <AppPlaceholder v-else>
                            Geen producten gevonden
                        </AppPlaceholder>
                    </section>

                    <template v-if="users && users.data && users.data.length">
                        <section>
                            <AppHeader>
                                <AppTitle as="h2"> Leden </AppTitle>
                            </AppHeader>

                            <AppUserGrid :users="users.data" />
                        </section>
                    </template>

                    <template
                        v-if="
                            categories &&
                            categories.data &&
                            categories.data.length
                        "
                    >
                        <section>
                            <AppHeader>
                                <AppTitle as="h2"> Categorieën </AppTitle>
                            </AppHeader>

                            <AppCategoryGrid :categories="categories.data" />
                        </section>
                    </template>

                    <template
                        v-if="brands && brands.data && brands.data.length"
                    >
                        <section>
                            <AppHeader>
                                <AppTitle as="h2"> Merken </AppTitle>
                            </AppHeader>

                            <AppBrandGrid :brands="brands.data" />
                        </section>
                    </template>
                </div>
            </AppPage>
        </AppContainer>
    </TheLayoutApp>
</template>
